export function binSearch(array: number[], value: number) {
  let left = 0;
  let right = array.length - 1;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);

    if (array[mid] < value) {
      left = mid + 1;
    } else {
      right = mid - 1;
    }
  }
  if (right < 0) {
    right = 0;
  }
  if (left >= array.length) {
    left = array.length - 1;
  }
  return [left, right];
}
